import { useStyles } from '@archipro-design/aria';
import * as React from 'react';
import * as S from './ErrorPageWrapper.style';

interface ErrorPageWrapperProps {
    children: React.ReactNode;
}

const ErrorPageWrapper = ({ children }: ErrorPageWrapperProps) => {
    const { css } = useStyles();

    return (
        <div className={css(S.BaseStyle)}>
            <div>{children}</div>
        </div>
    );
};

export default ErrorPageWrapper;
